import React, { useId } from 'react'

interface OpenIconProps {
  className?: string
}

export const OpenIcon: React.FC<OpenIconProps> = ({ className }) => {
  const id = useId()
  const paint0Id = `paint0_linear_${id}`
  const paint1Id = `paint1_linear_${id}`
  const paint2Id = `paint2_linear_${id}`
  const paint3Id = `paint3_linear_${id}`
  const paint4Id = `paint4_linear_${id}`
  const paint5Id = `paint5_linear_${id}`
  const paint6Id = `paint6_linear_${id}`

  return (
    <svg viewBox="0 0 24 25" fill="none" className={className}>
      <path
        d="M18.12 1L11.12 7M17.12 13.5L23.62 7.5"
        stroke={`url(#${paint0Id})`}
      />
      <path
        d="M11.13 23.38L12.99 18.63M4.54 16.00L2.62 22.00"
        stroke={`url(#${paint1Id})`}
      />
      <ellipse
        cx="13.98"
        cy="10.38"
        rx="2.58"
        ry="4.43"
        transform="rotate(-42.52 13.98 10.38)"
        stroke={`url(#${paint2Id})`}
      />
      <ellipse
        cx="8.82"
        cy="17.13"
        rx="2.58"
        ry="4.43"
        transform="rotate(107.48 8.82 17.13)"
        stroke={`url(#${paint3Id})`}
      />
      <path d="M7 18C7.5 16 7.46 11.23 3.5 10" stroke={`url(#${paint4Id})`} />
      <path d="M10 18C10.5 16 9.5 9.5 3 5" stroke={`url(#${paint5Id})`} />
      <path
        d="M14.28 9.45C12.22 9.42 7.63 8.14 7.46 4"
        stroke={`url(#${paint6Id})`}
      />
      <defs>
        <linearGradient
          id={paint0Id}
          x1="19.12"
          y1="3"
          x2="12.62"
          y2="9.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F4F4F" stopOpacity="0" />
          <stop offset="0.18" stopColor="#4F4F4F" stopOpacity="0.87" />
          <stop offset="0.65" stopColor="#C0C0C0" />
        </linearGradient>
        <linearGradient
          id={paint1Id}
          x1="9.12"
          y1="23.50"
          x2="10.44"
          y2="17.21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F4F4F" stopOpacity="0" />
          <stop offset="1" stopColor="#C0C0C0" />
        </linearGradient>
        <linearGradient
          id={paint2Id}
          x1="10.50"
          y1="11.42"
          x2="14.73"
          y2="11.24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F4F4F" stopOpacity="0" />
          <stop offset="0.87" stopColor="#C0C0C0" />
        </linearGradient>
        <linearGradient
          id={paint3Id}
          x1="5.34"
          y1="18.18"
          x2="9.58"
          y2="17.99"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F4F4F" stopOpacity="0" />
          <stop offset="0.87" stopColor="#C0C0C0" />
        </linearGradient>
        <linearGradient
          id={paint4Id}
          x1="7.39"
          y1="17"
          x2="5.80"
          y2="11.09"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F4F4F" stopOpacity="0" />
          <stop offset="0.37" stopColor="#C0C0C0" />
        </linearGradient>
        <linearGradient
          id={paint5Id}
          x1="10.39"
          y1="17"
          x2="8.80"
          y2="11.09"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F4F4F" stopOpacity="0" />
          <stop offset="0.37" stopColor="#C0C0C0" />
        </linearGradient>
        <linearGradient
          id={paint6Id}
          x1="13.22"
          y1="9.57"
          x2="7.92"
          y2="6.50"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F4F4F" stopOpacity="0" />
          <stop offset="0.37" stopColor="#C0C0C0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
